import {TSubjectId} from "./ISubject";
import {TDeviceId} from "./IDevice";
import {TStimConfig} from "./TStimConfig";

export type TEventId = string

export type TStimEventMetadata = {
    config: TStimConfig
}

export enum EventType {
    DEBUG = "Debug",
    NOTE = "Note",
    OTHER = "Other",
    PP_RELIEF = "pp_relief",
    PROTOCOL = "Protocol",
    SECTION = "Section",
    BP_DROP_HR_RISE_LONG = "bp_drop_hr_rise_long",
    BP_DROP_HR_RISE_SHORT = "bp_drop_hr_rise_short",
    BP_RISE_HR_DROP_LONG = "bp_rise_hr_drop_long",
    CHIP_ERROR_DETECTED = "chip_error_detected",
    ECG_QRS_SKIPPED = "ecg_QRS_skipped",
    GLUCOSE_ENTER_HIGH = "glucose_enter_high",
    HYPERTENSION_PP40_SELECT = "hypertension_PP40_select",
    HYPERTENSION_PP65 = "hypertension_PP65",
    IMPEDANCE_MEASURE = "impedance_measure",
    POSITION_LYING_SIDE1 = "position_lying_side1",
    POSITION_LYING_SIDE2 = "position_lying_side2",
    POSITION_UPRIGHT = "position_upright",
    STIM = "stim",
    STIM_CONFIGURE = "stim_configure",
    STIM_IN_PROGRESS = "stim_in_progress",
    STIM_INTERRUPT = "stim_interrupt"
}

/** Human-readable labels for event types shown in UI (e.g. dropdown, event list). */
const EVENT_TYPE_LABEL_OVERRIDES: Partial<Record<EventType, string>> = {
    [EventType.PP_RELIEF]: "% Pain Relief",
    [EventType.NOTE]: "Note",
};

/**
 * Returns the display label for an EventType.
 * Falls back to the raw enum value if no override is defined.
 */
export const getEventTypeLabel = (type: EventType): string =>
    EVENT_TYPE_LABEL_OVERRIDES[type] ?? type;

export enum EventFormat {
    TEXT = "text",
    MARKDOWN = "markdown",
}
export const EVENT_TYPES: Array<EventType> = [
    EventType.DEBUG,
    EventType.NOTE,
    EventType.OTHER,
    EventType.PP_RELIEF,
    EventType.PROTOCOL,
    EventType.SECTION,
    EventType.BP_DROP_HR_RISE_LONG,
    EventType.BP_DROP_HR_RISE_SHORT,
    EventType.BP_RISE_HR_DROP_LONG,
    EventType.CHIP_ERROR_DETECTED,
    EventType.ECG_QRS_SKIPPED,
    EventType.GLUCOSE_ENTER_HIGH,
    EventType.HYPERTENSION_PP40_SELECT,
    EventType.HYPERTENSION_PP65,
    EventType.IMPEDANCE_MEASURE,
    EventType.POSITION_LYING_SIDE1,
    EventType.POSITION_LYING_SIDE2,
    EventType.POSITION_UPRIGHT,
    EventType.STIM,
    EventType.STIM_CONFIGURE,
    EventType.STIM_IN_PROGRESS,
    EventType.STIM_INTERRUPT
]

export interface IEvent {
    id: TEventId
    subjectId: TSubjectId
    deviceId?: TDeviceId
    eventType: string
    metadata: Record<string, any>
    tags: Array<string>
    startTime: string
    endTime?: string
    readonly createdAt: string
}